import {arrayIntersection} from 'utils'

const hasAccess = (userRoles, availableForRoles) => {
    return arrayIntersection(availableForRoles, userRoles).length > 0;
};

export default hasAccess;